module.exports = __webpack_public_path__ + "4ac4458b875ff4dda81b14258d0d3719.png";